<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>产品</el-breadcrumb-item>
      <el-breadcrumb-item>产品分类</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="分类名称" prop="query">
            <el-input
              size="small"
              v-model="filter.query"
              placeholder="分类名称"
              @keyup.enter.native="requestItemCategories"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="分类级别" prop="level">
            <el-select v-model="filter.level" placeholder="请选择" size="small">
              <el-option key="0" label="所有分类" :value="0"></el-option>
              <el-option key="1" label="一级分类" :value="1"></el-option>
              <el-option key="2" label="二级分类" :value="2"></el-option>
            </el-select>
          </el-form-item>-->
        </el-form>
        <div class="mt-10">
          <el-button
            type="primary"
            size="small"
            @click="requestItemCategories()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane
          label="零件分类"
          name="ItemCategory"
          v-if="hasAuth('itemCategoryList')"
        ></el-tab-pane>
        <el-tab-pane
          label="设备分类"
          name="DeviceCategory"
          v-if="hasAuth('deviceCategoryList')"
        ></el-tab-pane>
      </el-tabs>
      <component
        v-bind:is="currentTabComponent"
        :filter="params"
        :user="user"
      ></component>
    </div>
  </div>
</template>
<script>
import ItemCategory from '@/views/product/item_category/item_category'
import DeviceCategory from '@/views/product/item_category/device_category'
import store from '@/store/store'
import { hasAuth } from '@/permission'

export default {
  components: {
    ItemCategory,
    DeviceCategory,
  },
  data() {
    return {
      hasAuth,
      filter: {
        query: '',
        level: '',
      },
      user: store.state.userInfo,
      params: {
        query: '',
        level: 0,
        size: 20,
        page: 1,
        category: hasAuth('itemCategoryList') ? 1 : 2,
      },
      currentTabComponent: hasAuth('itemCategoryList')
        ? 'ItemCategory'
        : 'DeviceCategory',
      activeName: hasAuth('itemCategoryList')
        ? 'ItemCategory'
        : 'DeviceCategory',
    }
  },
  methods: {
    handleTabClick(tab, event) {
      this.currentTabComponent = tab.name
      this.reset()
    },
    async requestItemCategories() {
      let data = this.params
      data.category = this.activeName == 'ItemCategory' ? 1 : 2
      data.query = this.filter.query
      data.level = this.filter.level
      this.params = data
    },
    reset() {
      this.params.page = 1
      this.$refs['filterForm'].resetFields()
      this.requestItemCategories()
    },
  },
}
</script>